module.exports = __webpack_public_path__ + "img/password-change-success.8d2b60b8.svg";